import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CardTable from "../../../../components/AdminTable/CardTable";
import Dropdown from "../../../../components/AdminDropdown/Dropdown";
import DeleteModal from "../../../../components/Modal/DeleteModal";
import { FaEdit, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { languageHelper } from "../../../../config/helperFunctions";
import { listTemplates, deleteTemplate } from "./invoiceTemplateApi";

function InvoiceBuilderList() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);
  const [source, setSource] = useState("server");

  const fetchData = useCallback(() => {
    setLoading(true);
    listTemplates(user).then(({ data, source }) => {
      setData(data);
      setSource(source);
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDelete = async (id) => {
    await deleteTemplate(user, id);
    toast.success("Template deleted", {
      position: "bottom-right",
      autoClose: 5000,
      theme: "colored",
    });
    setDeleteId(null);
    fetchData();
  };

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => navigate(`edit/${id}`),
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrash />,
      func: (id) => setDeleteId(id),
    },
  ];

  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Name"),
      accessorKey: "name",
    },
    {
      header: languageHelper("Fields"),
      cell: (row) => row.row.original?.fields?.length ?? 0,
    },
    {
      header: languageHelper("Actions"),
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];

  const buttonData = [
    {
      buttonText: languageHelper("New Invoice Template"),
      path: "new",
    },
  ];

  return (
    <main>
      {source === "local" && (
        <div className="mb-3 text-sm bg-yellow-50 text-yellow-800 border border-yellow-200 rounded-lg p-3">
          {languageHelper(
            "Backend endpoint for invoice templates isn't available yet — templates are being saved in this browser only (localStorage). They'll sync to the server automatically once that endpoint is added."
          )}
        </div>
      )}
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Invoice Builder")}
        buttonData={buttonData}
        loading={loading}
      />
      {deleteId && (
        <DeleteModal
          setIsOpen={setDeleteId}
          onDelete={() => handleDelete(deleteId)}
        />
      )}
    </main>
  );
}

export default InvoiceBuilderList;
